import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './components/general/AuthContext';
import logger from './utils/logger';

const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { auth, isInitialized } = useAuth();
  const isAuthenticated = !!auth?.isAuthenticated;
  const userRole = auth?.user?.role;

  logger.log('RoleProtectedRoute', 'Checking role-based access', {
    isInitialized, isAuthenticated, userRole, allowedRoles,
  });

  if (!isInitialized) return <div>Loading…</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const hasRequiredRole = allowedRoles.some(
    r => r.toLowerCase() === (userRole || '').toLowerCase()
  );

  if (!hasRequiredRole) {
    logger.log('RoleProtectedRoute', 'Access denied', { userRole, allowedRoles });
    return (
      <div style={{ padding: '40px', textAlign: 'center', marginTop: '100px' }}>
        <h2>Access Denied</h2>
        <p>This page is restricted to: {allowedRoles.join(', ')}</p>
        <a href="/" style={{ color: '#315FAC' }}>Return to Home</a>
      </div>
    );
  }

  logger.log('RoleProtectedRoute', 'Access granted');
  return children;
};

export default RoleProtectedRoute;
